import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree,Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})


export class PrivilegesGuard implements CanActivate {
  createCatalogStatus: boolean = false;
  constructor(
    private router: Router,
    private cookieService: CookieService,
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      
      // ;
      if(this.cookieService.get('user_privileges'))
      {
        if(this.cookieService.get('user_privileges').includes(next.data.privilegeKey))
        {
          this.createCatalogStatus = true;
          return true;
        }else if((localStorage.getItem('user_role') === 'admin' || localStorage.getItem('user_role') === 'cms_manager') && next.data.privilegeKey === 'application'){
          return true;
        }
        else
        {
          this.createCatalogStatus = false;
          return false
        }
      }
    //  this.createCatalogStatus = localStorage.getItem("user_session_id") ? true : false;

      // if(this.createCatalogStatus === true)
      // {
      //   return true;
      // }
      // else
      // {
        
      //   return true;
      // }

  }

}

// export class CreateMedialist implements CanActivate {
//   createMedialistStatus: boolean = false;
//   constructor(
//     private router: Router,
//     private cookieService: CookieService,
//   ) {}
//   canActivate(
//     next: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      
//       // ;
//       if(this.cookieService.get('user_privileges'))
//       {
//         if(this.cookieService.get('user_privileges').includes('create_media_list'))
//         {
//           this.createMedialistStatus = true;
//           return true;
//         }
//         else
//         {
//           this.createMedialistStatus = false;
//           return false
//         }
//       }
   
//   }

// }



// export class PrivilegesGuard implements CanActivate {
//   createMedialistStatus: boolean = false;
//   constructor(
//     private router: Router,
//     private cookieService: CookieService,
//   ) {}

//   canActivate(
//     next: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
//     // 
//     if(this.cookieService.get('user_privileges'))
//     {
//       if(this.cookieService.get('user_privileges').includes('create_media_list'))
//       {
//         this.createMedialistStatus = true;
//         return true;
//       }
//       else
//       {
//         this.createMedialistStatus = false;
//         return false
//       }
//     }
 
//   }
  
// }
